import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Eye, Smartphone } from 'lucide-react';
export function HookSection() {
  return <SectionWrapper className="bg-cyber-dark/50 border-y border-cyber-neon/10" data-id="element-165">
      <div className="text-center mb-12" data-id="element-166">
        <h2 className="text-3xl md:text-4xl text-white mb-4" data-id="element-167">
          ¿Alguna vez has sentido ese{' '}
          <span className="text-cyber-red text-shadow-neon-red" data-id="element-168">
            vacío en el estómago
          </span>{' '}
          al entrar a un lugar lleno de gente?
        </h2>
      </div>

      <div className="prose prose-invert prose-lg max-w-none font-sans text-gray-300 space-y-6" data-id="element-169">
        <p className="flex items-start gap-4" data-id="element-170">
          <Eye className="w-8 h-8 text-cyber-purple shrink-0 mt-1" data-id="element-171" />
          <span data-id="element-172">
            Esa sensación de que todos los ojos están puestos en ti, analizando
            cómo caminas, qué ropa traes y lo "raro" que te ves.
          </span>
        </p>

        <p className="flex items-start gap-4" data-id="element-173">
          <Smartphone className="w-8 h-8 text-cyber-purple shrink-0 mt-1" data-id="element-174" />
          <span data-id="element-175">
            Te quedas pegado al celular con la pantalla apagada solo para
            parecer ocupado. Quieres hablar, quieres conectar, pero tu garganta
            se cierra y tu cerebro se pone en blanco.
          </span>
        </p>

        <div className="p-6 mt-8 border-l-4 border-cyber-neon bg-cyber-neon/5 rounded-r-lg" data-id="element-176">
          <p className="text-xl font-mono text-white m-0" data-id="element-177">
            <strong className="text-cyber-neon" data-id="element-178">
              No eres raro, y no estás roto.
            </strong>{' '}
            Simplemente estás operando con un software social desactualizado.
            Pero eso se termina hoy.
          </p>
        </div>
      </div>
    </SectionWrapper>;
}